import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  TeacherLoadingState,
  TeacherPageShell,
  TeacherPreparationPosterPage,
  useTeacherAdventureOverview,
} from './teacherAdventureShared';

export const TeacherPreparationPostersPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const selectedDate = searchParams.get('date') ?? undefined;
  const selectedLessonRunId = searchParams.get('lessonRunId') ?? undefined;
  const { overview, isLoading, loadError } = useTeacherAdventureOverview(selectedDate, selectedLessonRunId);

  if (isLoading || loadError) {
    return (
      <TeacherPageShell title="探险准备海报" description="这里查看学生完成探险准备后的出发海报与准备摘要。">
        <TeacherLoadingState error={loadError} loadingText="正在加载探险准备海报..." />
      </TeacherPageShell>
    );
  }

  return <TeacherPreparationPosterPage records={overview.preparationPosterRecords} />;
};
